// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"22":"policy1","183":"policy0","629":"policy2","820":"policy3"}[chunkId] || chunkId) + "." + {"22":"0945d6f8","34":"7bc4d18a","183":"65d88748","629":"c38478d6","820":"840fa6d9"}[chunkId] + ".chunk.js";
};